import React, { useState, useEffect, useRef } from "react";

import "./allDishesSubsection.css";

import DishComponent from "../_dishComponent/DishComponent";
import DishEditor from "../_dishEditor/DishEditor";

import Pagination from "../../../utils/_pagination/Pagination";

const AllDishesSubsection = ({
  dishes,
  isDishesLoading,
  handleCreateDish,
  handleUpdateDish,
  handleDeleteDish
}) => {
  const dishesCopiesContainerRef = useRef(null);

  const [filteredDishes, setFilteredDishes] = useState([...dishes]);
  const [dishesCopies, setDishesCopies] = useState([]);

  const [filter, setFilter] = useState({});

  const [categoryFilterOptions, setCategoryFilterOptions] = useState([]);
  const [subcategoryFilterOptions, setSubcategoryFilterOptions] = useState([]);
  const [
    subcategoriesWithinCategories,
    setSubcategoriesWithinCategories
  ] = useState([]);

  // handle filters and selectDishOptions
  const handleSearchFilterChange = (e) => {
    const workingObject = {};
    workingObject.searchTerm = e.target.value;
    setFilter({ ...filter, ...workingObject });
  };

  const handleCategoryFilterChange = (e) => {
    const workingObject = {};
    workingObject.category = e.target.value;
    setFilter({ ...filter, ...workingObject });
  };

  const handleSubcategoryFilterChange = (e) => {
    const workingObject = {};
    workingObject.subcategory = e.target.value;
    setFilter({ ...filter, ...workingObject });
  };

  // handle copying dishes
  const handleCopyDish = (dish) => {
    setDishesCopies((dishesCopies) => [...dishesCopies, dish]);
    setTimeout(() => {
      dishesCopiesContainerRef.current.scrollIntoView(true);
    }, 500);
  };

  const removeOriginalIdFromCopiesArrayCallback = (originalId) => {
    setDishesCopies((dishesCopies) =>
      dishesCopies.filter((dish) => dish._id !== originalId)
    );
  };

  // handle setting filters
  const handleSetFilters = (dishes) => {
    let categoriesArray = dishes.map((dish) => dish.category);

    let subcategoriesArray = dishes.map((dish) => dish.subcategory);
    subcategoriesArray = subcategoriesArray.filter(
      (subcategory) => subcategory !== ""
    );

    //let subcategoriesWithinCategoriesArray = [];

    let uniqueCategories = categoriesArray.reduce(
      (acc, x) => acc.concat(acc.find((y) => y === x) ? [] : [x]),
      []
    );
    let uniqueSubcategories = subcategoriesArray.reduce(
      (acc, x) => acc.concat(acc.find((y) => y === x) ? [] : [x]),
      []
    );

    let subcategoriesWithinCategoriesArray = uniqueCategories.map(
      (category) => {
        let workingArray = [];
        let categoryObject = {
          category: category
        };
        categoryObject.subcategories = [];

        let dishesWithCategory = dishes.filter(
          (dish) => dish.category === category
        );

        dishesWithCategory.forEach((dish) =>
          workingArray.push(dish.subcategory)
        );

        workingArray = workingArray.filter((subcategory) => subcategory !== "");

        let uniqueWorkingArray = workingArray.reduce(
          (acc, x) => acc.concat(acc.find((y) => y === x) ? [] : [x]),
          []
        );

        uniqueWorkingArray.forEach((subcategory) =>
          categoryObject.subcategories.push(subcategory)
        );

        return categoryObject;
      }
    );

    setCategoryFilterOptions([...uniqueCategories]);
    setSubcategoryFilterOptions([...uniqueSubcategories]);
    setSubcategoriesWithinCategories([...subcategoriesWithinCategoriesArray]);
  };

  // refresh dishes
  useEffect(() => {
    setFilteredDishes([...dishes]);
    if (!categoryFilterOptions.length) {
      handleSetFilters(dishes);
    }
  }, [dishes]);

  // change filters based on each other
  // initial unique categories and subcategories

  // subcategory
  useEffect(() => {
    if (filter.category) {
      const workingObject = {};
      let subcategoryFilterOptionsArray = subcategoriesWithinCategories.filter(
        (item) => item.category === filter.category
      );

      setSubcategoryFilterOptions([
        ...subcategoryFilterOptionsArray[0].subcategories
      ]);

      // workingObject.subcategory = subcategoryFilterOptionsArray[0].subcategories[0];
      workingObject.subcategory = "";

      setFilter({ ...filter, ...workingObject });
    }
  }, [filter.category]);

  // change selectDishOptions based on filters
  useEffect(() => {
    let workingArray = [...dishes];

    if (filter.category) {
      workingArray = workingArray.filter(
        (dish) => dish.category === filter.category
      );
    }

    if (filter.subcategory) {
      workingArray = workingArray.filter(
        (dish) => dish.subcategory === filter.subcategory
      );
    }

    if (filter.searchTerm) {
      let term = filter.searchTerm.toLowerCase();
      workingArray = workingArray.filter((dish) =>
        dish.name.toLowerCase().includes(term)
      );
    }

    setFilteredDishes([...workingArray]);
  }, [filter, dishes]);

  if (dishes.length === 0 && isDishesLoading) {
    return <div>items are loading...</div>;
  }

  return (
    <div className="subSection allDishesSubsection">
      <h3>ALL ITEMS</h3>
      <div className="allDishesSubsection__filterControls">
        <div className="filterControls__searchFilterInput">
          <input
            type="text"
            placeholder="Enter item name..."
            value={filter.searchTerm ? filter.searchTerm : ""}
            onChange={handleSearchFilterChange}
          />
        </div>
        <div className="filterControls__categoryFilterSelect">
          <select
            name=""
            id=""
            value={filter.category}
            onChange={handleCategoryFilterChange}
          >
            <option value="">Category</option>
            {categoryFilterOptions &&
              categoryFilterOptions.map((category) => (
                <option value={category} key={category}>
                  {category}
                </option>
              ))}
          </select>
        </div>
        <div className="filterControls__subcategoryFilterSelect">
          <select
            name=""
            id=""
            value={filter.subcategory}
            onChange={handleSubcategoryFilterChange}
          >
            <option value="">Subcategory</option>
            {subcategoryFilterOptions &&
              subcategoryFilterOptions.map((subcategory) => (
                <option value={subcategory} key={subcategory}>
                  {subcategory}
                </option>
              ))}
          </select>
        </div>
      </div>
      <div className="allDishesSubsection__dishesContainer">
        {!isDishesLoading ? (
          filteredDishes.length > 0 ? (
            filteredDishes.length < 6 ? (
              filteredDishes.map((dish) => (
                <DishComponent
                  key={dish._id}
                  dish={dish}
                  dishes={dishes}
                  handleUpdateDish={handleUpdateDish}
                  handleCopyDish={handleCopyDish}
                  handleDeleteDish={handleDeleteDish}
                />
              ))
            ) : (
              <Pagination
                items={filteredDishes}
                itemsOnPage={5}
                topNav={true}
                bottomNav={true}
                cloneKey="dish"
                children={
                  <DishComponent
                    dishes={dishes}
                    handleUpdateDish={handleUpdateDish}
                    handleCopyDish={handleCopyDish}
                    handleDeleteDish={handleDeleteDish}
                  />
                }
              />
            )
          ) : (
            <div>No dishes matching the criteria</div>
          )
        ) : (
          <div>Loading...</div>
        )}
      </div>
      <div
        id="allDishesSubsection__copiesContainer"
        className="allDishesSubsection__copiesContainer"
        ref={dishesCopiesContainerRef}
        style={{ scrollMargin: "3em" }}
      >
        {dishesCopies.length && dishesCopies.length > 0 ? <h2>Copy</h2> : null}
        {dishesCopies.length
          ? dishesCopies.map((dishCopy) => (
              <DishEditor
                key={dishCopy._id}
                dish={dishCopy}
                dishes={dishes}
                isFromCopy={true}
                originalDishId={dishCopy._id}
                handleCreateDish={handleCreateDish}
                removeOriginalIdFromCopiesArrayCallback={
                  removeOriginalIdFromCopiesArrayCallback
                }
              />
            ))
          : null}
      </div>
    </div>
  );
};

export default AllDishesSubsection;
